import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShoppingBagEdit2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconShoppingBagEdit2"><Path d="M10.5 21.5H4L6 7.5H18L18.7143 12.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 7.5V6C15.5 4.067 13.933 2.5 12 2.5C10.067 2.5 8.5 4.067 8.5 6V7.5" stroke="currentColor" strokeLinecap="square"/><Path d="M13.5 22.5002V20.1668L17.75 15.9168C18.3943 15.2725 19.439 15.2725 20.0833 15.9168C20.7277 16.5612 20.7277 17.6058 20.0833 18.2502L15.8333 22.5002H13.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconShoppingBagEdit2;
